export const upConfigRouteToNavbar = (config) => {
    console.log("UPDATE FUNCTION => ", config);

    const rest = config;
    config.prop.upConfig(rest);
}